import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getBrokerInformation } from "../../store/broker";
import translations from "../../utils/translations";
const SelectCertificateCovers = ({
  coverTypes,
  location,
  coverOfCoverType,
  getCoversasisValue,
  handleCoverChange,
  handleChecked,
  storeBinder,
  defaultSelectedCheckedValue,
  buildingName,
  building,
  buildingIndex,
  locationIndex,
}) => {
  const buildingData = building || location; // use building data if provided, otherwise default to location
  const isBuilding = building ? true : false;
  let { information } = useSelector(getBrokerInformation);
  const languagePreference = information.languagepreference;
  const certificateTranslations = translations[languagePreference];
  return (
    <>
      <div
        style={{
          height: "800px",
          paddingRight: "7vmin",
          paddingLeft: "7vmin",
        }}
      >
        <div
          className="card"
          style={{
            height: "800px",
          }}
        >
          <div
            className="card-body "
            style={{
              height: "auto",
              overflowY: "auto",
              overflowX: "hidden",
              display: "block",
            }}
          >
            {/* <h2 style={{ color: "black" }}> {buildingName}</h2> */}
            <table className="table table-striped">
              <thead className="col">
                <tr>
                  <th scope="col-md-6">{certificateTranslations.coverage} </th>
                  <th scope="col-md-6">
                    {certificateTranslations.limitIncluded}
                  </th>
                  <th scope="col-md-6">Action</th>
                </tr>
              </thead>
              <tbody>
                {coverOfCoverType &&
                  coverOfCoverType.map((item, i) => (
                    <tr key={item.id}>
                      <td>
                        <label
                          style={{
                            cursor: "pointer",
                            fontWeight:
                              item.parentid === null ? "bold" : "normal",
                            color:
                              item.parentid === null
                                ? "your-desired-color"
                                : "inherit",
                          }}
                          htmlFor={`id-${item.id}`}
                        >
                          {item.parentid !== null ? `\u00A0 - ` : null}
                          {item?.name && item?.name[languagePreference] ? (
                                 <span style={{ fontWeight: "bold" }}>
                                    {item?.name[languagePreference]}
                                  </span>
                                ) : null}
                          {/* {item.parentid === null &&
                            item?.name[languagePreference]} */}
                          {/* {item.parentid === null ? (
                            <span style={{ fontWeight: "bold" }}>
                              {languagePreference === "fr"
                                ? item?.frname || item?.name
                                : item?.name}
                            </span>
                          ) : languagePreference === "fr" ? (
                            item?.frname || item?.name
                          ) : (
                            item?.name
                          )} */}
                          {/* {item.parentid === null ? (
                            <span style={{ fontWeight: "bold" }}>
                              {item?.name}
                            </span>
                          ) : (
                            item?.name
                          )} */}
                        </label>
                      </td>
                      <td>
                        <input
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          name={`name${i}`}
                          value={
                            //   getCoversasisValue(
                            //   // item && item.id,
                            // item.inputvaluetype,
                            //   buildingData?.id || location?.id,
                            //   buildingName
                            // )
                            getCoversasisValue(
                              item && item.id,
                              item.inputvaluetype,
                              locationIndex || location?.id,
                              buildingIndex
                            )
                          }
                          onChange={(event) => {
                            handleCoverChange(
                              event,
                              item.id,
                              location,
                              buildingIndex
                            );
                          }}
                        />
                      </td>
                      <td>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={item.id}
                            id={`id-${item.id}`}
                            style={{ cursor: "pointer" }}
                            onChange={(event) => {
                              handleChecked(
                                event,
                                item.id,
                                location,
                                buildingData,
                                isBuilding,
                                buildingIndex
                              );
                            }}
                            defaultChecked={defaultSelectedCheckedValue(
                              item.id,
                              location?.id,
                              buildingIndex,
                              isBuilding
                            )}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectCertificateCovers;
